import React, { FC } from 'react';

import { TooltippedButtonWrapper, TooltippedButtonWrapperProps } from '@tanium/react-button-base';

import Button from './Button';
import { ButtonProps } from './types';

export interface TooltippedButtonProps
  extends ButtonProps,
    Pick<TooltippedButtonWrapperProps, 'tooltipContent' | 'tooltipModifiers'> {}

const TooltippedButton = React.forwardRef<HTMLElement, TooltippedButtonProps>(
  ({ tooltipContent, tooltipModifiers, ...props }, forwardedRef) => (
    <TooltippedButtonWrapper
      tooltipContent={tooltipContent}
      tooltipModifiers={tooltipModifiers}
      disabled={props.disabled}
    >
      <Button {...props} ref={forwardedRef} />
    </TooltippedButtonWrapper>
  ),
);

TooltippedButton.displayName = 'TooltippedButton';
// This type cast provides better typings and Intellisense for consumers
export default TooltippedButton as FC<TooltippedButtonProps & { ref?: React.Ref<HTMLElement> }>;
